import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            BROKERAGE SERVICES
          </h2>
          <h3>Business Brokerage</h3>
          <h5><strong>Kinos</strong> provides brokerage services to tenants, vendors, buyers and landlords of residential and commercial premises. Our services are designed to help maximise the value of your asset, and to help you every step of the way of the transaction process.

Whether youre a seasoned home owner, a first-time buyer, an owner of residentialor a commercial portfolio, our advice is always tailored, and transparent. Our strong market knowledge, informed by in-house sector-leading research, ensures you receive the best possible advice every time, whatever your needs.
          </h5>
          <h5>Our Services
Sell-side Advisory Services

We work with entrepreneurial and family-owned, privately-held companies. Our clients are typically interested in:

Owners Exits: Facilitating a departure for company owners;
Management Acquisitions: Helping key managers acquire their company from its current owners;
Recapitalizations: Purchasing shares from current shareholders seeking liquidity to add capital to the balance sheet, or to reduce debt;
Industry Consolidations: Combining managements operating experience and relationships with new sources of capital and expertise to consolidate a fragmented industry.
Buy-side Advisory Services

We use a comprehensive approach to help our clients search for and acquire a company.We assist in this process by:

Working with our client to define the search criteria;
Utilizing databases and contacts in the industry to identify the best candidates;
Initiating communication with potential targets and performing preliminary due diligence to determine if the target is a good fit;
Analyzing the data to determine the offering price and optimal structure for the transaction;
Managing the due diligence process with our clients accountants and attorneys;
Closing out the transaction.

Valuations
We have significant experience in the valuation of privately-owned businesses across a wide range of industries, informing clients of the current value of their company by performing an extensive analysis of their business as well as evaluating industry trends and other various factors. </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
